import axios from "axios";
import { notifyTicketMutation } from "./localTicketEvents";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

api.interceptors.response.use(
	(response) => {
		notifyTicketMutation(response);
		return response;
	},
	(error) => Promise.reject(error)
);

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

export default api;
